import React, { FC, useMemo } from 'react';
import { DefaultColumnType, ReactTable } from '@td-client-frontend/common';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { Audit } from '../../../@types/Audit';

export const ActivityTable: FC<{ data: Audit[] }> = ({ data }) => {
  const dependentColumns: DefaultColumnType = useMemo(
    () => [
      {
        Header: 'Employer',
        accessor: 'main.letter.identifier.name'
      },
      {
        Header: 'Username',
        accessor: 'main.author.detail.uid'
      },
      {
        Header: 'Employer Activity',
        accessor: 'main.type'
      },
      {
        Header: 'Date',
        canSort: true,
        Cell: ({ row }) => {
          return moment(row.original.main.createdAt).format('MM/DD/YYYY hh:mm a');
        }
      },
      {
        Header: 'Status',
        canSort: true,
        accessor: 'jobStatus'
      },
      {
        Header: 'Actions',
        disableSortBy: true,
        accessor: (row) => {
          return (
            <Link className="flex text-primary-500 hover:text-primary-70" to={`/activity-log/${row._id}`}>
              View
            </Link>
          );
        },
        width: 50
      }
    ],
    []
  );
  return <ReactTable columns={dependentColumns} data={data} />;
};
